<cjm-layout-container
	class="c-home-header"
	asidePosition="right"
	alignItems="start"
	classesMain="c-home-header__content"
	[preventSpacing]="['top', 'bottom']"
	[layoutType]="assetUrl ? 'split-equal' : 'full-width'"
>
	<ng-container main>
		<ng-container *isAuthenticated="false">
			<h1 class="c-vloket-header c-vloket-header--h1">
				<span class="c-vloket-text-marking c-vloket-text-marking--line-through">
					{{ i18nKeys.Home.Header.Title.withoutName | translate }}
				</span>
			</h1>
		</ng-container>

		<ng-container *isAuthenticated="true">
			<h1 class="c-vloket-header c-vloket-header--h1">
				<span class="c-vloket-text-marking c-vloket-text-marking--line-through">
					{{ i18nKeys.Home.Header.Title.withName | translate: { name: userName } }}
				</span>
			</h1>
		</ng-container>

		<p>{{ i18nKeys.Home.Header.Intro | translate }}</p>

		<form class="c-home-header__search-form c-vloket-form">
			<cjm-input-wrapper
				class="c-input--with-icon-button"
				inputId="searchQuery"
				[warnWhenInvalid]="true"
				[hideLabel]="true"
				[showOptionalLabel]="false"
				[label]="i18nKeys.Home.Header.Search.Placeholder | translate"
			>
				<input
					#input
					type="text"
					cypressTag="Home.Header.Search.Field"
					[formControl]="searchControl"
					[placeholder]="i18nKeys.Home.Header.Search.Placeholder | translate"
					(keyup.enter)="handleSearchChanges()"
				/>

				@if (!!searchControl.value) {
					<button
						class="c-input__icon-button"
						cypressTag="Home.Header.Search.ButtonClear"
						type="button"
						[ariaLabel]="i18nKeys.Actions.Clear | translate"
						[title]="i18nKeys.Actions.Clear | translate"
						(click)="handleSearchClear()"
					>
						<fa-icon icon="fa-xmark" />
					</button>
				}

				<ng-container description [ngxErrors]="searchControl">
					<div ngxError="maxWordCountReached" showWhen="dirty">
						{{ i18nKeys.FormLabels.MaxSearchTerms | translate: { max: '3' } }}
					</div>
				</ng-container>
			</cjm-input-wrapper>

			<cjm-button
				type="button"
				cypressTag="Home.Header.Search.ButtonSubmit"
				[isDisabled]="searchControl.invalid"
				[classes]="buttonClasses.LinkButton"
				[title]="i18nKeys.Actions.Search | translate"
				(handleClick)="handleSearchChanges()"
			>
				{{ i18nKeys.Actions.Search | translate }}
			</cjm-button>
		</form>

		<div class="c-home-header__link-group-container">
			@if (!primaryLinksLoading && primaryLinks) {
				<div>
					<h3 class="c-vloket-header c-vloket-header--h3 c-home-header__link-group__title">
						<span class="c-vloket-text-marking c-vloket-text-marking--underline">
							{{ primaryLinks.title | translate }}
						</span>
					</h3>

					<ul class="c-home-header__link-group" cypressTag="Home.Header.LinkGroup.Group">
						@for (link of primaryLinks.links; track link.url) {
							<li class="c-home-header__link-item">
								<cjm-link
									cypressTag="Home.Header.LinkGroup.Item"
									[classes]="'c-home-header__link'"
									[to]="link.url"
									[noDecoration]="true"
									[icon]="linkIcon"
									[queryParams]="link.queryParams"
								>
									<span>{{ link.title | translate }}</span>
								</cjm-link>
							</li>
						}
					</ul>

					@for (link of primaryLinks.blockLinks; track link.url) {
						<cjm-link
							class="c-home-header__link c-home-header__block-link"
							cypressTag="Home.Header.LinkGroup.All"
							[to]="link.url"
							[noDecoration]="true"
							[icon]="{
								icon: 'fa-chevron-right',
								type: 'fa-solid',
								position: 'right'
							}"
						>
							<span>{{ link.title | translate }}</span>
						</cjm-link>
					}
				</div>
			} @else {
				<ng-container *ngTemplateOutlet="linksLoadingTmpl"></ng-container>
			}

			@if (!secondaryLinksLoading && secondaryLinks) {
				<div>
					<h3 class="c-vloket-header c-vloket-header--h3 c-home-header__link-group__title">
						<span class="c-vloket-text-marking c-vloket-text-marking--underline">
							{{ secondaryLinks.title | translate }}
						</span>
					</h3>

					<ul class="c-home-header__link-group" cypressTag="Home.Header.LinkGroup.Group">
						@for (link of secondaryLinks.links; track link) {
							<li class="c-home-header__link-item">
								<cjm-link
									cypressTag="Home.Header.LinkGroup.Item"
									[classes]="'c-home-header__link'"
									[to]="link.url"
									[noDecoration]="true"
									[icon]="linkIcon"
									[queryParams]="link.queryParams"
								>
									<span>{{ link.title | translate }}</span>
								</cjm-link>
							</li>
						}
					</ul>

					@for (link of secondaryLinks.blockLinks; track link.url) {
						<cjm-link
							class="c-home-header__link c-home-header__block-link"
							cypressTag="Home.Header.LinkGroup.All"
							[to]="link.url"
							[noDecoration]="true"
							[icon]="{
								icon: 'fa-chevron-right',
								type: 'fa-solid',
								position: 'right'
							}"
						>
							<span>{{ link.title | translate }}</span>
						</cjm-link>
					}
				</div>
			} @else {
				<ng-container *ngTemplateOutlet="linksLoadingTmpl"></ng-container>
			}
		</div>
	</ng-container>
	<div class="c-home-header__image" asideRight [style.background-image]="'url(' + assetUrl + ')'"></div>
</cjm-layout-container>

<ng-template #linksLoadingTmpl>
	<div class="u-width-100">
		<h3 class="c-vloket-header c-vloket-header--h3 c-home-header__link-group__title u-width-50">
			<span class="c-vloket-text-marking c-vloket-text-marking--underline">
				<ngx-skeleton-loader
					count="1"
					appearance="line"
					[theme]="{
						height: '1.5rem',
						'margin-bottom': 0
					}"
				/>
			</span>
		</h3>
		<ul class="c-home-header__link-group u-width-75">
			<li><ngx-skeleton-loader count="1" appearance="line" /></li>
			<li><ngx-skeleton-loader count="1" appearance="line" /></li>
			<li><ngx-skeleton-loader count="1" appearance="line" /></li>
			<li><ngx-skeleton-loader count="1" appearance="line" /></li>
			<li><ngx-skeleton-loader count="1" appearance="line" /></li>
			<li><ngx-skeleton-loader count="1" appearance="line" /></li>
		</ul>
		<div class="u-margin-top u-width-50">
			<ngx-skeleton-loader count="1" appearance="line" />
		</div>
	</div>
</ng-template>
